module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v(_vm._s(_vm._f("anyDate")(_vm.value, _vm.unit)))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-229a5f64!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/business/inputs/honrayDealtime.vue
// module id = 1793
// module chunks = 2